import getCasTableCellValue from '../getCasTableCellValue';
import ICasRenderCellProps from '../ICasRenderCellProps';

export function CasRenderNumberWithCommas(props: ICasRenderCellProps) {
  return getCasTableCellValue(props)?.toLocaleString();
}
